import { useQuery } from 'react-query';
import prettyMilliseconds from 'pretty-ms';
import { getSampleJob } from 'hooks/useRunABJob';
import useJobDetails from 'hooks/useJobDetails';
import { auth, useAuthState } from '../api/services/firebase';
import getUserStatistics from '../api/services/userStatistics';
import useAccountStore from '../store/accountStore';

const useGetUserStatistics = () => {
  const [user] = useAuthState(auth);
  const teamId = useAccountStore((state) => state.activeAccount.teamId);
  const sampleJob = getSampleJob() || null;
  const {
    cost = null,
    resultsPath = null,
    runStart = null,
    runEnd = null,
    createdOn = null,
    device = null,
  } = sampleJob || {};

  const { runtimeInMs } = useJobDetails({
    runStart,
    runEnd,
    cost,
    resultsPath,
    createdOn,
    device,
  });

  const { data, isLoading, error } = useQuery({
    queryKey: ['userStatistics', teamId],
    queryFn: getUserStatistics(user),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    enabled: !!user,
  });

  return {
    totalCount: sampleJob?.jobId ? ((data?.totalCount ?? 0) + 1) : (data?.totalCount ?? 0),
    totalCountCpu: sampleJob?.jobId ? ((data?.totalCpuCount ?? 0) + 1) : (data?.totalCpuCount ?? 0),
    totalCountGpu: data?.totalGpuCount,
    totalCountQuantum: data?.totalQuantumCount,
    totalRuntime: prettyMilliseconds(((data?.totalRuntime || 0) * 1000)
      + (sampleJob?.jobId ? runtimeInMs / 1000 : 0)),
    totalRuntimeCpu: prettyMilliseconds(((data?.totalCpuRuntime || 0) * 1000)
      + (sampleJob?.jobId ? runtimeInMs / 1000 : 0)),
    totalRuntimeGpu: prettyMilliseconds((data?.totalGpuRuntime || 0) * 1000),
    totalRuntimeQuantum: prettyMilliseconds((data?.totalQuantumRuntime || 0) * 1000),
    isLoading: !user || isLoading,
    error,
  };
};

export default useGetUserStatistics;
